export default __webpack_public_path__ + "static/media/about-bg.cf7deb8b.webp";